export function changeLocale(locale) {
	return {
		type: 'LOCALE_CHANGED',
		payload: { locale },
		data: { locale },
	};
}
